<template>
    <div class="report-card" @click="emitOpenDialog">
      <div class="report-content">
        {{ bugReport.summary }}
      </div>
      <div class="mt-2">
        <el-tag class="mr-2" v-if="bugReport.appType" type="primary">{{ bugReport.appType }}</el-tag>
        <el-tag v-if="bugReport.category" type="info">{{ bugReport.category }}</el-tag>
    </div>
      <div class="assignment-container">
        <el-popover placement="bottom-start" :width="300" trigger="click">
          <template #reference>
            <button v-if="assignedTo" @click.stop>
              <span class="avatar mr-0">{{ getInitials(assignedTo) }}</span>
            </button>
            <button v-else class="operations-btn" @click.stop>
              <i class="ri-user-fill"></i>
            </button>
          </template>
          <template #default>
            <el-select
              :model-value="assignedTo"
              @update:model-value="updateAssignment($event)"
              placeholder="Assign to"
              style="width: 100% !important"
            >
              <el-option
                class="assign-to-select"
                v-for="item in ['Arvin Tashakori', 'Megan Ma']"
                :key="item"
                :label="item"
                :value="item"
              >
                <span class="avatar">{{ getInitials(item) }}</span>
                <span>{{ item }}</span>
              </el-option>
            </el-select>
          </template>
        </el-popover>
      </div>
    </div>
</template>


<script>
import { updateDocument } from '../../../services/useDocument'
import { ref, watch } from 'vue'
export default {
  name: 'BugSummaryContainer',
  props: ['bugReport'],
  setup (props, context) {
    const { handlelUpdate } = updateDocument('bugReports', props.bugReport.id)
    const assignedTo = ref(props.bugReport.assignedTo)

    watch(() => props.bugReport.assignedTo, (newValue) => {
      assignedTo.value = newValue
    })
    const getInitials = (name) => {
      if (!name) return ''
      return name.split(' ').map(word => word[0]).join('').toUpperCase()
    }

    const updateAssignment = (name) => {
      assignedTo.value = name
      handlelUpdate({ assignedTo: name })
    }

    const emitOpenDialog = () => {
      context.emit('open-dialog', props.bugReport.id)
    }

    return {
      getInitials,
      updateAssignment,
      assignedTo,
      emitOpenDialog
    }
  }
}
</script>

  <style scoped>
  .report-card {
    cursor: pointer !important;
    user-select: none;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 3px !important;
    box-shadow: 0 1px 1px rgba(23, 43, 77, 0.2), 0 0 1px rgba(23, 43, 77, 0.2) !important;
    filter: none  !important;
    font-size: 14px;
    margin-bottom: 6px;
    background-color: var(--container-color);
    padding: 10px;
  }

  .report-card:hover {
    background-color: #f4f5f7 !important;
  }

  .avatar {
    display: inline-block;
    background-color: var(--accent-color); /* Avatar background color */
    color: white; /* Avatar text color */
    font-weight: bold;
    font-size: 12px; /* Decrease font size for more 'padding' */
    width: 28px; /* Increase width for proper spacing */
    height: 28px; /* Increase height for proper spacing */
    line-height: 28px; /* Adjust to center the text vertically, should be same as height */
    border-radius: 50%;
    text-align: center;
    margin-right: 8px; /* Space between the avatar and the name */
  }

  .operations-btn {
  background-color: var(--dark-grey);
  border: none;
  border-radius: 500px;
  cursor: pointer;
  padding: 2px 7px;
  margin: 0;
  font-size: 14px;
  color: var(--text-color);
}

.report-content {
  flex: 1; /* Ensures it takes up all available space pushing the assignment container to the bottom/right */
}

.assignment-container {
  display: flex;
  justify-content: flex-end; /* Aligns the assignment buttons to the right */
  padding: 10px; /* Add padding for spacing around buttons */
}

  </style>

  <style>
  .report-card .el-card__body {
    padding: 10px !important;
  }
  </style>
